import _ from "lodash";
import { request } from "./request";
import { search } from "./search";

export const crud = (record) => {
  const modelNamePlural = _.snakeCase(record.modelName) + "s";
  const modelBaseEndpoint = `/${modelNamePlural}`;

  const deserializeRes = (response) => record.deserialize(response[_.snakeCase(record.modelName)]);

  const createOrUpdateRequestOpts = (model) => {
    const body = JSON.stringify(record.serialize(model));
    const headers = typeof body === "string" ? {} : { "content-type": undefined };
    return {
      body,
      headers,
    };
  };

  return {
    create: (model) =>
      request.post(modelBaseEndpoint, createOrUpdateRequestOpts(model)).then((response) => ({
        result: deserializeRes(response),
        ...response,
      })),
    read: (id) => request.get(`${modelBaseEndpoint}/${id}.json`).then(deserializeRes),
    update: (model) =>
      request.patch(`${modelBaseEndpoint}/${model.id}`, createOrUpdateRequestOpts(model)).then(deserializeRes),
    delete: (id) => request.delete(`${modelBaseEndpoint}/${id}`),
    list: (params) =>
      request.get(`${modelBaseEndpoint}.json`, { params }).then(({ results, ...rest }) => ({
        results: results.map(record.deserialize),
        ...rest,
      })),
    search: (params) => search({ ...params, types: [modelNamePlural] }),
  };
};
